import { render } from "./ExclaminationCircle.vue?vue&type=template&id=4f6cc174"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__